import React from 'react';
import { EventModel } from './useEventManagement';
import EventFormSteps, { FORM_STEPS } from './EventFormSteps';
import { AdminModal } from '../../pages/admin/ConfirmationDialogs';

const EventFormModal: React.FC<{ model: EventModel }> = ({ model }) => {
  const { showForm, setShowForm, editingEvent, formStep, setFormStep, saving, handleSave } = model;
  if (!showForm) return null;
  return (
    <AdminModal ariaLabel={editingEvent ? 'Edit event' : 'Create event'} onCancel={() => setShowForm(false)} maxWidth="42rem">
      <div>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold" style={{ color: 'var(--rp-text)' }}>
            {editingEvent ? 'Edit Event' : 'Create Event'}
          </h2>
          <button onClick={() => setShowForm(false)} className="admin-icon-btn" aria-label="Close form">×</button>
        </div>

        {/* Step Indicators */}
        <div className="flex gap-1 mb-6">
          {FORM_STEPS.map((step, i) => (
            <button
              key={step}
              onClick={() => setFormStep(i)}
              className={`flex-1 py-2 text-xs font-semibold rounded-lg transition-all ${
                i === formStep ? 'text-white' : 'hover:bg-white/5'
              }`}
              style={i === formStep ? { backgroundColor: 'var(--rp-primary)' } : { color: 'var(--rp-text-secondary)' }}
            >
              {step}
            </button>
          ))}
        </div>

        {/* Step Content */}
        <EventFormSteps model={model} />

        {/* Navigation */}
        <div className="flex justify-between mt-6 pt-4 border-t border-white/10">
          <button
            onClick={() => setFormStep(Math.max(0, formStep - 1))}
            disabled={formStep === 0}
            className="px-4 py-2 rounded-lg text-sm disabled:opacity-30 hover:bg-white/5 transition-colors"
            style={{ color: 'var(--rp-text-secondary)' }}
          >
            Back
          </button>
          <div className="flex gap-3">
            <button onClick={() => setShowForm(false)} className="px-4 py-2 rounded-lg text-sm" style={{ color: 'var(--rp-text-secondary)' }}>
              Cancel
            </button>
            {formStep < FORM_STEPS.length - 1 ? (
              <button
                onClick={() => setFormStep(formStep + 1)}
                className="px-4 py-2 rounded-lg text-sm font-semibold text-white"
                style={{ backgroundColor: 'var(--admin-primary)' }}
              >
                Next
              </button>
            ) : (
              <button
                onClick={handleSave}
                disabled={saving}
                className="admin-btn admin-btn-primary disabled:opacity-50"
              >
                {saving ? 'Saving...' : editingEvent ? 'Update Event' : 'Create Event'}
              </button>
            )}
          </div>
        </div>
      </div>
    </AdminModal>
  );
};

export default EventFormModal;
